export const TRANSLATIONS_ES = {
  name: "Yon Frank Trigozo Blacido",

  home: "Inicio",
  aboutme: "Sobre mí",
  resume: "Currículum",
  portfolios: "Portafolio",
  contact: "Contacto",

  age: "Edad",
  dob: "Fecha de nacimiento",
  dobA: "17/01/2002",
  address: "Dirección",
  addressA: "Peru,Huánuco",
  email: "Correo electrónico",

  aboutmeTwo: "Soy un diseñador web residente en Huánuco, en busca de una posición laboral como diseñador web. Soy una persona organizada, responsable, comprometida y graduada del instituto superior Juan Bosco de Huánuco,Distrito Huánuco. Actualmente, estoy aprendiendo sobre diseño de interfaces de usuario.",
  mySkills: "Habilidades",
  Program: "Programas",
  español: "Peru",
  english: "Inglés",
  korean: "Coreano",

  resumeTwo: "Currículum",
  education: "Educación",
  educationYear: "2021 - 2023",
  educationTitle: "Educación Técnica",
  educationText: "Juan Bosco de Huánuco, carrera técnica  en Desarrollo de Sistema de Información",
  educationYearTwo: "2014 - 2018",
  educationTitleTwo: "Secundaria",
  educationTextTwo: "Certificado de Estudio",

  experience: "Experiencia",
  experienceYear: "2024",
  experienceTitle: "Diseño de Páginas Web",
  experienceText: "En 2024, me interesé por el diseño de sitios web en el Instituto Técnico de Teherán y decidí aprenderlo.",
  experienceYearTwo: "2022",
  experienceTitleTwo: "Diseñador y Fotógrafo",
  experienceTextTwo: "En el año 2022, durante seis meses, Distrito Municipal de Amarilis comencé hacer practicas Pre-Profesionales.",
  experienceYearThree: "2022",
  experienceTitleThree: "UI",
  experienceTextThree: "Recientemente comencé a aprender sobre este campo.",

  contactTwo: "Contacto",
  getInTouch: "Ponte en contacto conmigo",
  findMe: "Mi ubicación",
  teharnIran: "Huánuco, Perú",
  mailMe: "Envíame un correo",
  emailTwo: "yontrigozoblacido@gmail.com",
  callMe: "Llámame",
  phoneNum: "946-155-005",

  contactForm: "Formulario de contacto",
  nameInp: "Nombre",
  messageInp: "Mensaje",
  submitBtn: "Enviar",

  errorNameOne: "El nombre es obligatorio",
  errorNameTwo: "El nombre debe tener más de dos letras",
  errorEmailOne: "El correo electrónico es obligatorio",
  errorEmailTwo: "Correo electrónico no válido",
  errorMessageOne: "El mensaje es obligatorio",
  errorMessageTwo: "El mensaje ingresado es insuficiente",

  toastSucc: "El mensaje fue enviado con éxito 👍",
  toastErr: "Error al enviar ❌",
};